import { Button } from "@components/atoms/Button"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, usePostTitleEditor } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Page Header Article",
  icon: "block-default",
  postMetaBlock: {
    fieldName: "pageHeaderArticle",
    postTypes: ["article"],
  },
  conditions: {
    postTypes: ["article"],
  },
}

export default defineBlock("content/page-header-article", (props) => {
  const authors = props.authorAuthor || []

  return (
    <div className={cn("w-grid mx-auto flex my-10 pt-7")}>
      <div className="w-full grid grid-cols-1 md:grid-cols-2">
        {(env.admin || props.featuredImages?.[0]?.mediaItemUrl) && (
          <div
            className="w-full aspect-square rounded-xl overflow-hidden order-2 md:order-1 themed-bg"
            data-transition="scale"
          >
            {env.admin && !props.featuredImages?.[0]?.mediaItemUrl && (
              <div className="w-full h-full bg-grey flex items-center justify-center type-ui">Select media</div>
            )}
            {props.featuredImages?.[0]?.mediaItemUrl && (
              <ResponsiveImage {...props.featuredImages[0]} className="w-full h-full" objectFit="cover" fadeOnLoad />
            )}
          </div>
        )}
        <div
          className="w-full p-7 self-stretch flex flex-col justify-between items-start gap-7 md:gap-5 rounded-xl border-2 border-black md:order-2"
          data-transition="fade-up"
        >
          <div className="flex items-center gap-1" data-transition="children/fade-up">
            {props.categories?.map(
              (category, index) =>
                !!category && (
                  <Button key={index} href={category.uri || ""} size="sm">
                    {category.name}
                  </Button>
                ),
            )}
          </div>
          <div className="flex flex-col gap-4" data-transition="children/fade-up">
            <p className="type-label-s-caps">Article</p>
            <h1 className="type-title-m md:type-title-l text-balance">
              {env.admin ? (
                <EditableText as="span" store={usePostTitleEditor()} className="" placeholder="Enter a title" />
              ) : (
                props.article?.title
              )}
            </h1>
          </div>
          <div className="flex type-body-xl md:type-title-s" data-transition="children/fade-up">
            {props.authorAuthor?.title && (
              <Link href={props.authorAuthor.uri} className="underline-link">
                {props.authorAuthor?.title}
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  )
})
